import { useActiveOrganization } from "./active-organization-context"

export const useActiveOrganizationId = (): {
  activeOrganizationId: string | undefined
} => {
  const { activeOrganization } = useActiveOrganization()

  return { activeOrganizationId: activeOrganization?.id }
}
